import InnerPage from "../components/InnerPage";
import PageBanner from "../components/PageBanner";
import SceneCard from "../components/SceneCard";
import { products, scenes } from "../data/site";

const tabs = products.map((p) => ({ id: p.tab, label: p.name }));

export default function Products() {
  const videoUrl = 'https://wqxq-dev.oss-cn-chengdu.aliyuncs.com/portal/ai-video/%E7%89%9B%E5%86%8D%E6%9D%A5%E7%AC%AC%E4%B8%80%E9%9B%86.mp4';

  return (
    <InnerPage
      banner={<PageBanner title="产品" en="PRODUCTS" variant="product" />}
      tabs={tabs}
    >
      {products.map((product) => (
        <section id={product.tab} className="panel" key={product.id}>
          <div className="container">
            <h2 className="small-title">
              {product.name}—{product.subtitle}
            </h2>
            <div className="prose">
              <p>{product.body}</p>
            </div>
            {product.id === "shufang" && (
              <div className="scene-grid product-scenes">
                {scenes.map((scene) => (
                  <SceneCard key={scene.name} {...scene} />
                ))}
              </div>
            )}
            {product.id === "qulihuo" && (
              <div className="feature-band tone-plaza">
                <ul>
                  <li>食</li>
                  <li>住</li>
                  <li>行</li>
                  <li>游</li>
                  <li>购</li>
                  <li>娱</li>
                </ul>
                <p>以 LBS、XR 与数字孪生，把线下人流转化为可持续的数字消费。</p>
              </div>
            )}
            {product.id === "quip" && (
              <div className="ip-block">
                <article>
                  <h3>三体「宇宙闪烁」增强现实观测站</h3>
                  <p>
                    三体宇宙是《三体》三部曲内容开发及商业衍生的全球独家版权方，致力于打造具有国际影响力的中国顶尖科幻品牌。项目以「宇宙闪烁」「幽灵倒计时」为核心内容点，呈现城市 AR 场景、裸眼 3D 大屏与线下观测站场馆。
                  </p>
                </article>
                <aside className="portrait-card tone-cosmos">
                  <div className="portrait-art" />
                  <div>
                    <h3>趣IP</h3>
                    <p>多模态元宇宙 × 顶级文化 IP</p>
                  </div>
                </aside>
              </div>
            )}
            {product.id === "niuzailai" && (
              <div className="niuzailai-block">
                <aside className="portrait-card portrait-card2 ">
                  <div className="portrait-art">
                    <video
                      src={videoUrl}
                      controls
                      style={{ flex: 1, maxWidth: 400 }}
                    />
                  </div>
                  <div>
                    <h3>牛再来</h3>
                    <p>第一集</p>
                  </div>
                </aside>
              </div>
            )}
          </div>
        </section>
      ))}
    </InnerPage>
  );
}
